import React from 'react';
import styles from './styles.css';

export default function DataUnavailableOverlay({ message, onDismiss }) {
	/* eslint-disable i18next/no-literal-string */
	return (
		<div className={styles.overlay}>
			<div className={styles.message}>
				<button className={styles.close} onClick={onDismiss}>
					×
				</button>
				<p>{message}</p>
			</div>
		</div>
	);
	/* eslint-enable i18next/no-literal-string */
}
